import React, { Component } from 'react';
import PropTypes from 'prop-types';
import throttle from '../../util/throttle';

import './Switch.scss';

class Switch extends Component {
  static defaultProps = {
    onChange: function () {},
    throttleInterval: 500,
  };

  constructor(props) {
    super(props);
    this.state = {
      value: undefined,
    };

    if (this.props.throttleInterval > 0) {
      this.change = throttle(this.props.onChange, this.props.throttleInterval, this);
    } else {
      this.change = this.props.onChange;
    }
  }

  componentDidMount() {
    this.setState({
      value: this.props.value,
    });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.value != this.props.value) {
      this.setState({
        value: this.props.value,
      });
    }
  }

  handleChange = (e) => {
    const { checked, name } = e.target;
    this.change({ name, checked, value: this.state.value });
  };

  render() {
    const { name, checked, label, id, disabled, ItemRenderer, rendererValues, className } = this.props;

    return (
      <div className={`switch_box ${className}`}>
        <label className='switch_label'>
          {ItemRenderer ? <ItemRenderer label={label} option={rendererValues} /> : label}
        </label>
        <label className='switch'>
          <input
            name={name}
            id={id}
            checked={checked}
            type="checkbox"
            onChange={this.handleChange}
            disabled={disabled}
          />
          <span className='slider round'></span>
        </label>
      </div>
    );
  }
}

Switch.propTypes = {
  name: PropTypes.string.isRequired,
  className: PropTypes.string,
  label: PropTypes.string,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  disabled: PropTypes.bool,
  checked: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  ItemRenderer: PropTypes.func,
  rendererValues: PropTypes.object,
  throttleInterval: PropTypes.number,
};

export default Switch;
